
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveaway-luluandgeorgia-sss",
      function () {
        return require("private-next-pages/giveaway-luluandgeorgia-sss/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveaway-luluandgeorgia-sss"])
      });
    }
  